/// <amd-module name="Test/AttachmentsView/Source/AttachmentsLogStoreViewSource" />
import * as TestManagementService from "Test/Client/TestManagementServices";
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { IVssPageContext } from "VSS/Platform/Context";
import { ITestLogWithContinuationToken, TestLogListItem } from "Test/common-util/Contracts/ExtendedTest";

export class AttachmentsLogStoreViewSource {
    private logStoreAttachmentList: TestLogListItem[];

    public async getLogStoreAttachments(pageContext: IVssPageContext, testRunId: number, testResultId: number, subResultId: number, type: TCMContracts.TestLogType): Promise<TestLogListItem[]> {
        let testLogWithContinuationToken: ITestLogWithContinuationToken;
        if (!!this.logStoreAttachmentList && !!this.logStoreAttachmentList[this.logStoreAttachmentList.length - 1].continuationToken) {
            //fetch more items
            testLogWithContinuationToken = await this.fetchAttachments(pageContext, testRunId, testResultId, subResultId, type);
            this.removeLoadMoreElement();
            this.updateAttachments(testLogWithContinuationToken);
            if (!!testLogWithContinuationToken.continuationToken) {
                this.appendLoadMoreElement(testLogWithContinuationToken.continuationToken);
            }
        } else {
            //make call and update the local results - first call
            testLogWithContinuationToken = await this.fetchAttachments(pageContext, testRunId, testResultId, subResultId, type);
            this.addAttachments(testLogWithContinuationToken);
            if (!!testLogWithContinuationToken.continuationToken) {
                this.appendLoadMoreElement(testLogWithContinuationToken.continuationToken);
            }
        }
        return this.logStoreAttachmentList;
    }

    public async getTestLogStoreEndpointDetailsForAttachment(pageContext: IVssPageContext, attachment: TestLogListItem): Promise<TCMContracts.TestLogStoreEndpointDetails> {
        const tcmService = pageContext.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        let testLogStoreEndpointDetails: TCMContracts.TestLogStoreEndpointDetails;
        if (attachment.testLog.logReference.resultId > 0) {
            if (attachment.testLog.logReference.subResultId > 0) {
                testLogStoreEndpointDetails = await tcmService.getTestLogStoreEndpointDetailsForSubResultLog(
                    attachment.testLog.logReference.runId,
                    attachment.testLog.logReference.resultId,
                    attachment.testLog.logReference.subResultId,
                    attachment.testLog.logReference.type,
                    attachment.testLog.logReference.filePath);
            } else {
                testLogStoreEndpointDetails = await tcmService.getTestLogStoreEndpointDetailsForResultLog(
                    attachment.testLog.logReference.runId,
                    attachment.testLog.logReference.resultId,
                    attachment.testLog.logReference.type,
                    attachment.testLog.logReference.filePath);
            }
        } else {
            testLogStoreEndpointDetails = await tcmService.getTestLogStoreEndpointDetailsForRunLog(attachment.testLog.logReference.runId, attachment.testLog.logReference.type, attachment.testLog.logReference.filePath)
        }

        return testLogStoreEndpointDetails;
    }

    public async getTestLogStoreEndpointDetailsForAttachmentNonObject(pageContext: IVssPageContext, runId: number, resultId: number, subResultId:number, type: TCMContracts.TestLogType, filePath:string): Promise<TCMContracts.TestLogStoreEndpointDetails> {
        const tcmService = pageContext.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        let testLogStoreEndpointDetails: TCMContracts.TestLogStoreEndpointDetails;
        if (resultId > 0) {
            if (subResultId > 0) {
                testLogStoreEndpointDetails = await tcmService.getTestLogStoreEndpointDetailsForSubResultLog(
                    runId,
                    resultId,
                    subResultId,
                    type,
                    filePath);
            } else {
                testLogStoreEndpointDetails = await tcmService.getTestLogStoreEndpointDetailsForResultLog(
                    runId,
                    resultId,
                    type,
                    filePath);
            }
        } else {
            testLogStoreEndpointDetails = await tcmService.getTestLogStoreEndpointDetailsForRunLog(runId,
                    type,
                    filePath);
        }

        return testLogStoreEndpointDetails;
    }

    public async loadAttachmentContent(endPointUri: string): Promise<ArrayBuffer> {
        let options = {
            method: "GET",
        } as RequestInit;

        let response = await fetch(endPointUri, options);
        return response.arrayBuffer();
    }

    private async fetchAttachments(pageContext: IVssPageContext, testRunId: number, testResultId: number, subResultId: number, type: TCMContracts.TestLogType): Promise<ITestLogWithContinuationToken> {
        const tcmService = pageContext.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        let testLogWithContinuationToken: ITestLogWithContinuationToken;
        var continuationToken;
        if (!!this.logStoreAttachmentList) {
            continuationToken = this.logStoreAttachmentList[this.logStoreAttachmentList.length - 1].continuationToken;
        }
        if (testResultId > 0) {
            if (subResultId > 0) {
                testLogWithContinuationToken = await tcmService.getTestSubResultLogs(testRunId, testResultId, subResultId, type, undefined, undefined, undefined, undefined, continuationToken);
            } else {
                testLogWithContinuationToken = await tcmService.getTestResultLogs(testRunId, testResultId, type, undefined, undefined, undefined, undefined, continuationToken);
            }
        } else {
            testLogWithContinuationToken = await tcmService.getTestRunLogs(testRunId, type, undefined, undefined, undefined, undefined, continuationToken);
        }

        return testLogWithContinuationToken;
    }

    private updateAttachments(testLogWithContinuationToken: ITestLogWithContinuationToken) {
        //update results
        this.logStoreAttachmentList = this.logStoreAttachmentList.concat(
            testLogWithContinuationToken.results.map(element => {
                var newElement: TestLogListItem = {
                    testLog: element
                };
                return newElement;
            })
        );
    }

    private addAttachments(testLogWithContinuationToken: ITestLogWithContinuationToken) {
        this.logStoreAttachmentList = testLogWithContinuationToken.results.map(element => {
            var newElement: TestLogListItem = {
                testLog: element
            };
            return newElement;
        });
    }

    private appendLoadMoreElement(continuationToken: string) {
        var lastElement: TestLogListItem = {
            continuationToken: continuationToken,
            testLog: this.logStoreAttachmentList[this.logStoreAttachmentList.length - 1].testLog
        };
        this.logStoreAttachmentList.push(lastElement);
    }

    private removeLoadMoreElement() {
        this.logStoreAttachmentList.splice(this.logStoreAttachmentList.length - 1);
    }
}
